import {
    DropPosition,
    NavigationEntityState,
    NavigationItemExpandedState,
} from '~ui/store/slices/navigation-tree';

export function isInnerDrop(dropTargetItem: NavigationEntityState, position: DropPosition) {
    if (position === 'inner') {
        return true;
    }

    // if the item is expanded, put draggedItem as children
    if (
        position === 'bottom' &&
        dropTargetItem.expandedState !== NavigationItemExpandedState.Closed
    ) {
        return true;
    }

    return false;
}
